import { render, staticRenderFns } from "./okTry.vue?vue&type=template&id=61a2fc40&scoped=true&"
import script from "./okTry.vue?vue&type=script&lang=js&"
export * from "./okTry.vue?vue&type=script&lang=js&"
import style0 from "./okTry.vue?vue&type=style&index=0&id=61a2fc40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a2fc40",
  null
  
)

export default component.exports